import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { NavLink } from 'fluxible-router';
import OrderItem from '../../models/OrderItem';
import shallowCompare from '../../lib/shallowCompare';
import Select from '../Select';
import ShoppingCartActions from '../../actions/ShoppingCartActions';
import QuantitySelector from '../QuantitySelector';
import TrashcanPng from '../images/trashcan.png';
import TrashcanSvg from '../images/trashcan.svg';
import styles from './index.sass';

class ShoppingCartItem extends React.Component {
  static contextTypes = {
    executeAction : React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  static propTypes = {
    className: React.PropTypes.string,
    item: React.PropTypes.instanceOf(OrderItem),
    storeId: React.PropTypes.string.isRequired,
    alert: React.PropTypes.object
  };

  static defaultProps = {
    className: ''
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickRemoveButton(e) {
    this.context.executeAction(ShoppingCartActions.removeItem, {
      store_id : this.props.storeId,
      item_id  : this.props.item.id,
      inventoryRecord: this.props.item.inventory_record
    });
  }

  render() {
    let { item } = this.props;
    let inventoryRecord = item.inventory_record;

    let name;
    let photo = <img className={styles.photo} src={inventoryRecord.photo_hash.getClosestToTarget(90)} />;
    let nameProps = { className: styles.name };
    if(inventoryRecord.slug) {
      let linkProps = {
        routeName: 'inventoryRecord',
        navParams: {
          id: inventoryRecord.id,
          slug: inventoryRecord.slug
        }
      };
      name = <NavLink {...nameProps} {...linkProps}>{inventoryRecord.brand} {inventoryRecord.name}</NavLink>;
      photo = <NavLink className={styles.photoLink} {...linkProps}>{photo}</NavLink>;
    } else {
      name = <p {...nameProps}>{inventoryRecord.name}</p>;
    }

    let mobileRemoveButtonProps = {
      className: styles.mobileRemoveButton,
      onClick: this.handleOnClickRemoveButton.bind(this)
    };
    let mobileRemoveButton = (
      <button {...mobileRemoveButtonProps}>
        <img src={TrashcanPng} srcSet={TrashcanSvg} alt="Remove from cart" />
      </button>
    );
    let quantitySelectorProps = {
      className: styles.quantitySelector,
      showBuyButton: false,
      navigateToBagOnSuccess: false,
      inventoryRecord: inventoryRecord,
      customer: this.props.customer,
      storeId: this.props.storeId
    };

    return (
      <div className={`${styles.shoppingCartItem} ${this.props.className}`}>
        {photo}
        <div className={styles.nameAndDetails}>
          {name}
          <div>
            <span className={styles.price}>{inventoryRecord.price_text} per item</span>
            <span className={styles.bullet}>&nbsp;•&nbsp;</span>
            <button className={styles.removeButton} onClick={this.handleOnClickRemoveButton.bind(this)}>Remove</button>
          </div>
        </div>
        {mobileRemoveButton}
        <QuantitySelector {...quantitySelectorProps} />
        <p className={styles.subtotal}>{item.total_text}</p>
      </div>
    );
  }
}

export default ShoppingCartItem;



// WEBPACK FOOTER //
// banquet/components/ShoppingCartItem/index.js